import { ETypeSubstrat } from './enum/type-substrat';
import { DensiteSubstrat } from './enum/densite-substrat';
import { PrelevementIBD } from '../IBD/prelevement-ibd';
import { PrelevementVitesse } from '../Shared/prelevement-vitesse';

export class Substrat {
    id: number;
    processId: number;

    Type: ETypeSubstrat;
    Pourcentage: number;
    Densite: DensiteSubstrat;
    PrelevementVitesses: PrelevementVitesse[] = [];

    static mapFromJSON(json): Substrat {
        const s = new Substrat();

        s.Type = json.type;
        s.Pourcentage = json.pourcentage;
        s.Densite = json.densite;

        if (json.prelevementVitesses) {
            s.PrelevementVitesses = json.prelevementVitesses.map(jsonItem => PrelevementVitesse.mapFromJSON(jsonItem));
        }

        return s;
    }
}
